import { NgModule } from '@angular/core';
import { HostContextService } from './host-context.service';
import { HostApiService } from './host-api.service';

@NgModule({
  providers: [HostContextService, HostApiService],
})
export class HostContextHostModule {}
